// extracted by mini-css-extract-plugin
export var animationContainer = "_pg-0";
export var footer = "_pg-1";
export var gray = "_pg-2";
export var lineItem = "_pg-3";
export var lineItemImage = "_pg-4";
export var lineItemInfo = "_pg-5";
export var lineItemText = "_pg-6";
export var lineItems = "_pg-7";
export var modalContent = "_pg-8";
export var options = "_pg-9";
export var orderName = "_pg-a";
export var refundAmount = "_pg-b";